export enum EIcons {
    LOAD = 'loading',
    LOGO = 'app-logotype',
    LOGO2 = 'app-logotype2',
    Minus = 'squared-minus',
    Note = 'note-reminder',
    CLOS = 'close-icon',
    TRSH = 'trash-button',
    TRSH2 = 'trash-button_2',
    PDVCE = 'photo-device',
    PLUS = 'squared-plus',
    AROW = 'triangle-arrow',
    EDIT = 'edit-icon',
    PEN = 'edit-pen',
    SAVE = 'save-icon',
    SEEPSWRD = 'see-password',
    HIDPSWRD = 'hide-password',
    SRCH = 'search-icon'
}

export interface IIcon {
    iconName: EIcons
    width?: string
    height?: string
    color?: string
}
